import { BasePreviewViewStore } from "core/stores";
import { ConfirmingReportItemService } from "application/confirming-report/services";
import { observable } from "mobx";
import { toUTCDate } from "core/utils";
import _ from 'lodash';

class ConfirmingReportItemPreviewModalViewStore extends BasePreviewViewStore {
    @observable accessor confirmingReportItems = [];
    @observable accessor salesOrderNumber = null;
    @observable accessor confirmingReportId = null;
    constructor(rootStore, componentProps) {
        const confirmingReportItemService = new ConfirmingReportItemService(rootStore.application.baasic.apiClient);

        const salesOrderNumber = componentProps.modalParams.data.salesOrderNumber;
        const confirmingReportId = componentProps.modalParams.data.confirmingReportId;
        super(rootStore, {
            name: "confirming-report-item-preview-modal",
            routes: {
            },
            actions: () => {
                return {
                    get: async () => {
                        const response = await confirmingReportItemService.find(
                            {
                                confirmingReportId: confirmingReportId,
                                salesOrderNumber: salesOrderNumber
                            });
                        _.extend(response.data,
                            {
                                item: _.map(response.data.item, (item => {
                                    return _.extend(
                                        item, {
                                            deliveryScheduledDate: item.deliveryScheduledDate && toUTCDate(item.deliveryScheduledDate),
                                            dosToDate: item.dosToDate && toUTCDate(item.dosToDate),
                                            dateTransmitted: item.dateTransmitted && toUTCDate(item.dateTransmitted),
                                            initialDate: item.initialDate && toUTCDate(item.initialDate),
                                            revisedDate: item.revisedDate && toUTCDate(item.revisedDate),
                                            doctorSignedDate: item.doctorSignedDate && toUTCDate(item.doctorSignedDate),                                                                       
                                        }
                                    );
                                }))                         
                            });
                        this.confirmingReportItems = response.data.item;
                        this.salesOrderNumber = salesOrderNumber;
                        this.confirmingReportId = confirmingReportId;
                        return response.data;
                    } 
                };
            },
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
    }

}

export default ConfirmingReportItemPreviewModalViewStore;
